<template>
    <div class="main"
         :class="{'main-hide-text': shrink}">
        <div class="sidebar-menu-con"
             :style="{width: shrink?'65px':'200px', overflow: shrink ? 'visible' : 'auto'}">
            <div :style="{background: bgColor}"
                 class="ivu-shrinkable-menu">
                <div class="logo-con"
                     v-show="true">
                    <div class="site-name"
                         v-show="!shrink">{{siteName}}</div>
                    <div class="site-name"
                         v-show="shrink">{{siteShortName}}</div>
                </div>
                <sidebar-menu :shrink="shrink"
                              :open-names="openedSubmenuArr"
                              :theme="theme"
                              :icon-size="15"
                              :menu-list="menuList"></sidebar-menu>
            </div>
        </div>
        <div class="main-header-con"
             :style="{paddingLeft: shrink?'60px':'200px'}">
            <div class="main-header">
                <div class="navicon-con">
                    <el-button icon="el-icon-arrow-left"
                               size="mini"
                               circle
                               :style="{transform: 'rotateZ(' + (this.shrink ? '-180' : '0') + 'deg)'}"
                               @click="toggleClick">
                    </el-button>
                </div>
                <div class="header-middle-con">
                    <div class="main-breadcrumb">
                        <breadcrumb-nav :currentPath="currentPath"></breadcrumb-nav>
                    </div>
                </div>
                <div class="header-avator-con">
                    <div class="book-list-con"></div>
                    <div class="message-con switch-theme">
                        <k-icon name="notice"
                                color="#ff5151"
                                size="20"
                                :dot="false" />
                    </div>
                    <div class="user-dropdown-menu-con">
                        <el-dropdown @command="onCommand">
                            <span>超级管理员<i class="el-icon-arrow-down el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="modify_password">修改密码</el-dropdown-item>
                                <el-dropdown-item command="logout">安全退出</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
            <div class="tags-con">
                <tags-page-opened :pageTagsList="pageTagsList"></tags-page-opened>
            </div>
        </div>
        <div class="single-page-con"
             :style="{left: shrink?'60px':'200px'}">
            <div class="single-page">
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive"></router-view>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"></router-view>
            </div>
        </div>
        <PopupEditPwd ref="popup_edit_pwd"></PopupEditPwd>
    </div>
</template>
<script>
import breadcrumbNav from '@/components/common/breadcrumn-nav'
import tagsPageOpened from '@/components/common/tags-page-opened'
import sidebarMenu from '@/components/common/sidebar-menu'
import util from '@/libs/util'
import PopupEditPwd from '@/components/common/PopupEditPwd'
import {
    removeToken
} from '@/api/auth';
import { siteName, siteShortName } from '@/api/const'
export default {
    components: {
        breadcrumbNav, tagsPageOpened, sidebarMenu, PopupEditPwd
    },
    data () {
        return {
            shrink: false,
            openedSubmenuArr: this.$store.state.app.openedSubmenuArr,
            theme: 'dark',
            siteName: siteName,
            siteShortName: siteShortName
        }
    },

    computed: {
        bgColor () {
            return this.theme === 'dark' ? '#495060' : '#fff';
        },
        menuList () {
            return this.$store.state.app.menuList;
        },
        currentPath () {
            return this.$store.state.app.currentPath; // 当前面包屑数组
        },
        pageTagsList () {
            return this.$store.state.app.pageOpenedList;
        },

        cachePage () {
            return this.$store.state.app.cachePage;
        }
    },
    watch: {
        $route (to) {
            this.$store.commit('setCurrentPageName', to.name);
            let pathArr = util.setCurrentPath(this, to.name);
            if (pathArr.length > 2) {
                this.$store.commit('addOpenSubmenu', pathArr[1].name);
            }
            localStorage.currentPageName = to.name;
        }
    },
    mounted () {
        this.init();
    },
    methods: {
        init () {

        },
        onCommand (command) {
            console.info(command)
            switch (command) {
                case 'modify_password':
                    this.$refs['popup_edit_pwd'].show()
                    break;
                case 'logout':
                    this.handleLogout()
                    break;
            }
        },
        handleLogout () {
            removeToken()
            window.localStorage.removeItem('user')
            this.$router.replace({
                path: '/login'
            });
        },
        toggleClick () {
            this.shrink = !this.shrink;
        },
    }
}
</script>
<style lang="scss" scoped>
html,
body {
    width: 100%;
    height: 100%;

    overflow: hidden;
}

.search-con {
    padding: 10px 0;

    .search {
        &-col {
            display: inline-block;
            width: 200px;
        }

        &-input {
            display: inline-block;
            width: 200px;
            margin-left: 2px;
        }

        &-btn {
            margin-left: 2px;
        }
    }
}

.lock-screen-back {
    border-radius: 50%;
    z-index: -1;
    box-shadow: 0 0 0 0 #667aa6 inset;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: all 3s;
}

.main {
    position: absolute;
    min-width: 1200px;
    background-color: #fff;
    width: 100%;
    height: 100%;

    .unlock-con {
        width: 0px;
        height: 0px;
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 11000;
    }

    .sidebar-menu-con {
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 21;
        transition: width 0.3s;

        .ivu-shrinkable-menu {
            height: 100%;
            width: 100%;
        }
    }

    .layout-text {
        display: inline-block;
        white-space: nowrap;
        position: absolute;
    }

    .main-hide-text .layout-text {
        display: none;
    }

    &-content-container {
        position: relative;
    }

    &-header-con {
        box-sizing: border-box;
        position: fixed;
        display: block;
        padding-left: 200px;
        width: 100%;
        height: auto;
        z-index: 20;
        box-shadow: 0 2px 1px 1px rgba(14, 7, 7, 0);
        transition: padding 0.3s;
        background-color: #e4e4e4;
    }

    &-breadcrumb {
        display: flex;
        flex-direction: column;
        height: 40px;
        justify-content: center;
    }

    &-menu-left {
        background: #464c5b;
        height: 100%;
    }

    .tags-con {
        height: 40px;
        line-height: 35px;
        z-index: -1;
        overflow: hidden;
        background: #fff;
        display: flex;
        align-items: center;
        border-top: solid 3px #f0f0f0;
        border-bottom: solid 2px #f0f0f0;
    }

    &-header {
        height: 60px;
        background: #fff;

        position: relative;
        z-index: 11;

        .navicon-con {
            display: inline-block;
            text-align: center;
            line-height: 60px;
            width: 60px;
        }

        .header-middle-con {
            position: absolute;
            left: 60px;
            top: 0;
            right: 340px;
            bottom: 0;
            padding: 10px;
            overflow: hidden;
        }

        .header-avator-con {
            position: absolute;
            right: 20px;
            top: 0;
            height: 100%;
            width: 300px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;

            .switch-theme-con {
                display: inline-block;
                width: 40px;
                height: 100%;
            }

            .book-list-con {
                display: inline-block;
                width: 140px;
                padding: 18px 0;
                text-align: right;
                cursor: pointer;
                color: #667aa6;
            }

            .message-con {
                display: flex;
                width: 40px;
                height: 100%;
                justify-content: center;
                align-items: center;
                cursor: pointer;
            }

            .user-dropdown-menu-con {
                display: flex;
                width: 120px;
                height: 100%;
                justify-content: center;
                align-items: center;
            }

            .change-skin {
                font-size: 14px;
                font-weight: 500;
                padding-right: 5px;
            }

            .switch-theme {
                height: 100%;
            }

            .user-dropdown {
                &-menu-con {
                    position: absolute;
                    right: 0;
                    top: 0;
                    height: 100%;

                    .main-user-name {
                        display: inline-block;
                        width: 80px;
                        word-break: keep-all;
                        white-space: nowrap;
                        vertical-align: middle;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        text-align: right;
                    }
                }

                &-innercon {
                    height: 100%;
                    padding-right: 14px;
                }
            }

            .full-screen-btn-con {
                display: inline-block;
                width: 30px;
                padding: 18px 0;
                text-align: center;
                cursor: pointer;

                i {
                    vertical-align: middle;
                }
            }

            .lock-screen-btn-con {
                display: inline-block;
                width: 30px;
                padding: 18px 0;
                text-align: center;
                cursor: pointer;

                i {
                    vertical-align: middle;
                }
            }
        }
    }

    .single-page-con {
        position: absolute;
        top: 105px;
        right: 10px;
        bottom: 0;
        overflow: auto;
        background-color: #f0f0f0;
        z-index: 1;
        transition: left 0.3s;

        .single-page {
            margin: 10px 10px;
            background-color: #fff;
            padding: 10px;
        }
    }

    &-copy {
        text-align: center;
        padding: 10px 0 20px;
        color: #9ea7b4;
    }
}

.taglist-moving-animation-move {
    transition: transform 0.3s;
}

.logo-con {
    padding: 0px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #028d25;
    .site-name {
        line-height: 44px;
        font-size: 28px;
        font-family: "PingFang SC", "宋体", "微软雅黑", Geneva, Verdana, Arial,
            sans-serif;
        color: #fff;
    }
    img {
        height: 44px;
        width: auto;
    }
}
</style>
